import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const failures = ["Los libros de 'cocina rápida' en realidad toman 45 minutos si cuentas el tiempo de picar y limpiar.", "El 'Meal Prep' del domingo te quita tu único día de descanso y para el jueves la comida ya sabe a cartón.", 'Las dietas restrictivas no funcionan cuando tienes una familia que alimentar y un presupuesto que cuidar.', 'Comprar ingredientes orgánicos frescos que terminas tirando a la basura porque se pudrieron antes de que tuvieras tiempo de usarlos.'];
export function FailedSolutions() {
  return <section className="py-20 px-4 bg-brand-bg" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-16">
          <h2 className="text-4xl md:text-5xl mb-6 text-brand-dark" data-id="element-17">
            ¿Por Qué Lo Que Has Probado No Funciona?
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-xl border border-stone-200 shadow-sm" data-id="element-19">
              <div className="flex-shrink-0 bg-brand-red-light p-2 rounded-full mt-1" data-id="element-20">
                <XIcon className="w-5 h-5 text-brand-red" data-id="element-21" />
              </div>
              <p className="text-lg text-stone-700 leading-relaxed pt-1" data-id="element-22">
                {text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}